/* Framory instant quick-add sheet (see snippets/quick-add-sheet.liquid).
   Variants are embedded per card; the add itself goes through the theme's own
   <form is="product-form">, so the cart drawer / events stay untouched. */
(function () {
  if (customElements.get('fp-quick-add')) return;

  class FpQuickAdd extends HTMLElement {
    connectedCallback() {
      this.variants = JSON.parse(this.querySelector('[data-variants]').textContent);
      this.money = this.getAttribute('data-money') || '£{{amount}}';
      this.sel = {};
      const def = this.variants.find((v) => String(v.id) === this.getAttribute('data-default')) || this.variants[0];
      if (def) { this.sel.o1 = def.o1; this.sel.o2 = def.o2; }

      this.addEventListener('click', (e) => {
        const pill = e.target.closest('.fp-qa__pill');
        if (pill) {
          if (pill.dataset.o1 !== undefined) this.sel.o1 = pill.dataset.o1;
          if (pill.dataset.o2 !== undefined) this.sel.o2 = pill.dataset.o2;
          this.render();
          return;
        }
        if (e.target.closest('[data-close]')) this.close();
      });
      this._esc = (e) => { if (e.key === 'Escape' && !this.hidden) this.close(); };

      // Optimistic: the theme needs ~1.3s (add + cart refresh) before the drawer opens. Close the sheet at once and
      // show a small "Adding…" pill so the tap feels instant; the pill goes away when the cart confirms or errors.
      const form = this.querySelector('form');
      if (form) form.addEventListener('submit', () => { if (this.querySelector('[data-add]').getAttribute('aria-disabled') === 'true') return; this.close(); FpQuickAdd.toast('Adding to cart…', true); });
      if (window.theme && theme.pubsub) {
        this._unsub = theme.pubsub.subscribe(theme.pubsub.PUB_SUB_EVENTS.cartUpdate, () => { if (!this.hidden) this.close(); const t = document.getElementById('fp-qa-toast'); if (t && t.dataset.busy === '1') FpQuickAdd.toast(null); });
        this._unsubErr = theme.pubsub.subscribe(theme.pubsub.PUB_SUB_EVENTS.cartError, () => { FpQuickAdd.toast('Could not add — please try again', false, 2600); });
      }
      this.render();
    }

    disconnectedCallback() { if (this._unsub) this._unsub(); if (this._unsubErr) this._unsubErr(); }

    static toast(text, busy, ttl) {
      let el = document.getElementById('fp-qa-toast');
      clearTimeout(FpQuickAdd._toastT);
      if (!text) { if (el) el.classList.remove('is-on'); return; }
      if (!el) { el = document.createElement('div'); el.id = 'fp-qa-toast'; el.className = 'fp-qa-toast'; el.setAttribute('role', 'status'); document.body.appendChild(el); }
      el.innerHTML = (busy ? '<span class="fp-qa-toast__dot"></span>' : '') + '<span></span>'; el.dataset.busy = busy ? '1' : '0';
      el.lastElementChild.textContent = text;
      setTimeout(() => el.classList.add('is-on'), 10);
      FpQuickAdd._toastT = setTimeout(() => el.classList.remove('is-on'), ttl || 6000);
    }

    fmt(cents) {
      if (window.theme && theme.Currency && theme.Currency.formatMoney) return theme.Currency.formatMoney(cents, this.money);
      return '£' + (cents / 100).toFixed(2);
    }

    current() {
      return this.variants.find((v) => v.o1 === this.sel.o1 && (this.sel.o2 === undefined || v.o2 === this.sel.o2));
    }

    render() {
      const v = this.current();
      this.querySelectorAll('.fp-qa__pill').forEach((p) => {
        const on = (p.dataset.o1 !== undefined && p.dataset.o1 === this.sel.o1) || (p.dataset.o2 !== undefined && p.dataset.o2 === this.sel.o2);
        p.classList.toggle('is-on', on);
        // grey out combos that don't exist / are sold out (e.g. A1 + Black)
        let ok = true;
        if (p.dataset.o1 !== undefined) ok = this.variants.some((x) => x.o1 === p.dataset.o1 && x.a && (this.sel.o2 === undefined || x.o2 === this.sel.o2 || !this.variants.some((y) => y.o1 === p.dataset.o1 && y.o2 === this.sel.o2)));
        if (p.dataset.o2 !== undefined) ok = this.variants.some((x) => x.o2 === p.dataset.o2 && x.a && x.o1 === this.sel.o1);
        p.classList.toggle('is-off', !ok);
      });
      const price = this.querySelector('[data-price]'), cmp = this.querySelector('[data-compare]');
      const id = this.querySelector('[data-id]'), add = this.querySelector('[data-add]');
      const addPrice = this.querySelector('[data-add-price]'), addLabel = this.querySelector('[data-add-label]');
      if (!v) {
        // combo not offered (e.g. A0 Black) → snap frame back to the first available for this size
        const alt = this.variants.find((x) => x.o1 === this.sel.o1 && x.a);
        if (alt && alt.o2 !== this.sel.o2) { this.sel.o2 = alt.o2; return this.render(); }
        add.setAttribute('aria-disabled', 'true'); addLabel.textContent = 'Unavailable'; return;
      }
      price.textContent = this.fmt(v.p);
      if (v.c > v.p) { cmp.textContent = this.fmt(v.c); cmp.hidden = false; } else cmp.hidden = true;
      id.value = v.id;
      addPrice.textContent = this.fmt(v.p);
      if (v.a) { add.removeAttribute('aria-disabled'); addLabel.textContent = add.dataset.label || 'Add to cart'; }
      else { add.setAttribute('aria-disabled', 'true'); addLabel.textContent = 'Sold out'; }
      const full = this.querySelector('.fp-qa__full');
      if (full) full.href = full.href.replace(/variant=\d+/, 'variant=' + v.id);
    }

    open(trigger) {
      this._trigger = trigger;
      // Portal to <body>: product cards have transforms, which would trap position:fixed inside the card.
      if (this.parentElement !== document.body) document.body.appendChild(this);
      this.hidden = false;
      document.body.classList.add('fp-qa-open');
      document.addEventListener('keydown', this._esc);
      setTimeout(() => this.classList.add('is-open'), 20); // not rAF: it never fires in background tabs
    }

    close() {
      this.classList.remove('is-open');
      document.body.classList.remove('fp-qa-open');
      document.removeEventListener('keydown', this._esc);
      setTimeout(() => { this.hidden = true; if (this._trigger) this._trigger.focus(); }, 220);
    }
  }
  customElements.define('fp-quick-add', FpQuickAdd);

  // Card buttons → open the sheet that belongs to the same card.
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-fp-quick-add]');
    if (!btn) return;
    e.preventDefault();
    const sheet = document.getElementById(btn.getAttribute('data-fp-quick-add'));
    if (sheet) { const l = sheet.querySelector('[data-add]'); if (l && !l.dataset.label) l.dataset.label = l.querySelector('[data-add-label]').textContent; sheet.open(btn); }
  });
})();
